"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtocolDTO = void 0;
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
var room_1 = __importDefault(require("./room"));
var ProtocolData = /** @class */ (function () {
    function ProtocolData() {
        this.qAld = 0;
        this.rooms = [];
        this.schutzziel1 = { description: '' };
        this.schutzziel2 = { description: '' };
    }
    return ProtocolData;
}());
var ProtocolDTO = /** @class */ (function () {
    function ProtocolDTO(data) {
        this.id = '';
        this.title = '';
        this.description = '';
        this.image = '';
        this.data = new ProtocolData;
        this.status = 'open';
        this.deleted = false;
        this.createdAt = new Date;
        this.updateAt = new Date;
        this.createdBy = '';
        this.account = '';
        Object.assign(this, lodash_clonedeep_1.default(data));
        // TODO: there might be a better way in typescript to cast given values to types!?
        this.data.rooms = this.data.rooms.map(function (room) { return new room_1.default(room); });
    }
    return ProtocolDTO;
}());
exports.ProtocolDTO = ProtocolDTO;
var Protocol = /** @class */ (function (_super) {
    __extends(Protocol, _super);
    function Protocol() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Protocol.prototype, "adjoiningRoom", {
        get: function () {
            return this.data.rooms.find(function (room) { return room.isAdjoiningRoom; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Protocol.prototype, "fWirkKomp", {
        get: function () {
            return this.data.multistory ? 0.8 : 0.7;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Protocol.prototype, "n", {
        get: function () {
            // bisherige 4m³/kW Regel?
            if (this.data.houseType === 7) {
                return 0.4;
            }
            // FIXME: we cut off after 2 digits in the past - not doing it, makes
            // the tests fail but is it actually good to cut it off?
            // TRGI 1: 0.17 vs 0.16898
            // TRGI 2: 0.19 vs 0.19498
            return +((this.fWirkKomp * this.n50 * 0.1857).toFixed(2));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Protocol.prototype, "n50", {
        get: function () {
            if (this.data.n50measured) {
                return this.data.n50measured;
            }
            if (!this.data.houseType) {
                return 0;
            }
            switch (this.data.houseType) {
                case 1:
                case 2: return 1.0;
                case 3:
                case 4: return 1.5;
                case 5:
                case 6: return 2.0;
                case 7: return 3.0;
                default:
                    throw new Error('unexpected housetype');
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Protocol.prototype, "output", {
        get: function () {
            return this.data.rooms.reduce(function (sum, room) { return room.output + sum; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Protocol.prototype, "qBed", {
        get: function () {
            return this.output * 1.6;
        },
        enumerable: false,
        configurable: true
    });
    Protocol.prototype.qVLanr = function (withModification) {
        var _this = this;
        return this.data.rooms.reduce(function (acc, room) { return acc + room.qVLanr(_this.n, withModification, _this.data.qAld); }, 0);
    };
    Object.defineProperty(Protocol.prototype, "qVLanrAfter", {
        get: function () {
            return this.qVLanr(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Protocol.prototype, "qVLanrBefore", {
        get: function () {
            return this.qVLanr(false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Protocol.prototype, "rlv", {
        /**
         * Raum-Leistungs-Verhältnis des Aufstellraums
         */
        get: function () {
            // First Room is Main Room
            var room = this.data.rooms[0];
            return room.volume / room.output;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Protocol.prototype, "rlvExtended", {
        /**
         * Raum-Leistungs-Verhältnis des Aufstellraums + verbundenen Nebenraums, wenn angegeben
         */
        get: function () {
            var _a;
            // Return RLV if there's no Adjoining Room
            if (!this.adjoiningRoom) {
                return this.rlv;
            }
            // First Room is Main Room
            var room = this.data.rooms[0];
            // Add Adjoining Room Volume
            var volume = room.volume + ((_a = this.adjoiningRoom) === null || _a === void 0 ? void 0 : _a.volume);
            return volume / room.output;
        },
        enumerable: false,
        configurable: true
    });
    return Protocol;
}(ProtocolDTO));
exports.default = Protocol;
